import { takeLatest, put, all, call } from 'redux-saga/effects';
import { AxiosCall } from "../../../utils/axios";
import * as actions from './actions';

function* fetchGlobalStats() {
    try {
        const result = yield call(AxiosCall, '/dashboard/stats/global_stats/');
        yield put(actions.fetchGlobalStatsSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchGlobalStatsFailure(e));
    }
}

export default function* globalStatsSaga() {
    yield all([
        // Watchers
        takeLatest(actions.FETCH_GLOBAL_STATS.REQUEST, fetchGlobalStats),
    ])
}
